import { Link } from "react-router-dom";
import { BiEdit, BiTrash } from "react-icons/bi";
import { UserCog } from "lucide-react";
import { ConsultansTable } from "./styles";
import {
  flattenStaffUsers,
  getUserRoleLabel,
  type StaffUserWithRole,
  type StaffUsersByRole,
} from "../../utils/userRoles";

type StaffUsersTableProps = {
  users: StaffUsersByRole;
  onRemoveUser: (userId: number) => void;
  onChangeRole: (user: StaffUserWithRole) => void;
};

export default function StaffUsersTable({
  users,
  onRemoveUser,
  onChangeRole,
}: StaffUsersTableProps) {
  const rows = flattenStaffUsers(users);

  return (
    <ConsultansTable cellPadding="0" cellSpacing="0">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Email</th>
          <th>Telefone</th>
          <th>Função</th>
          <th>Papel</th>
          <th>Editar</th>
          <th>Excluir</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((staffUser) => (
          <tr key={staffUser.id}>
            <td>{staffUser.first_name}</td>
            <td>{staffUser.email}</td>
            <td id="td-phone">{staffUser.phone}</td>
            <td>{getUserRoleLabel(staffUser.roleId)}</td>
            <td>
              <button
                type="button"
                title="Alterar papel"
                aria-label={`Alterar papel de ${staffUser.first_name}`}
                onClick={() => onChangeRole(staffUser)}
              >
                <UserCog className="h-6 w-6 cursor-pointer text-[#003882]" />
              </button>
            </td>
            <td>
              <Link to={`/edit-user/${staffUser.id}`}>
                <BiEdit color="#003882" size={24} />
              </Link>
            </td>
            <td>
              <BiTrash
                color="#E00000"
                size={24}
                onClick={() => onRemoveUser(staffUser.id)}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </ConsultansTable>
  );
}
